 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTBRITTMONTERO from '@/components/Text/BrittMontero'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTCONTENTSUNDERPRESSURE from '@/components/Text/ContentsUnderPressure'
 import TEXT1COPYRIGHT from '@/components/Text/1copyright'
 import TEXT11 from '@/components/Text/11'
 import TEXT12 from '@/components/Text/12'
 import TEXT13 from '@/components/Text/13'
 import TEXT14 from '@/components/Text/14'
 import TEXT15 from '@/components/Text/15'
 import TEXT16 from '@/components/Text/16'
 import TEXT17 from '@/components/Text/17'
 import TEXT18 from '@/components/Text/18'
 import TEXT19 from '@/components/Text/19'
 import TEXT110 from '@/components/Text/110'
 import TEXT111 from '@/components/Text/111'
 import TEXT112 from '@/components/Text/112'
 import TEXT113 from '@/components/Text/113'
 import TEXT114 from '@/components/Text/114'
 import TEXT115 from '@/components/Text/115'
 import TEXT116 from '@/components/Text/116'
 import TEXT117 from '@/components/Text/117'
 import TEXT118 from '@/components/Text/118'
 import TEXT119 from '@/components/Text/119'
 import TEXT120 from '@/components/Text/120'
 import TEXT121 from '@/components/Text/121'
 import TEXT122 from '@/components/Text/122'
 import TEXT1ACK from '@/components/Text/1ack'
 import TEXTMIAMIITSMURDER from '@/components/Text/MiamiItsMurder'
 import TEXT2COPYRIGHT from '@/components/Text/2copyright'
 import TEXT21 from '@/components/Text/21'
 import TEXT22 from '@/components/Text/22'
 import TEXT23 from '@/components/Text/23'
 import TEXT24 from '@/components/Text/24'
 import TEXT25 from '@/components/Text/25'
 import TEXT26 from '@/components/Text/26'
 import TEXT27 from '@/components/Text/27'
 import TEXT28 from '@/components/Text/28'
 import TEXT29 from '@/components/Text/29'
 import TEXT210 from '@/components/Text/210'
 import TEXT211 from '@/components/Text/211'
 import TEXT212 from '@/components/Text/212'
 import TEXT213 from '@/components/Text/213'
 import TEXT214 from '@/components/Text/214'
 import TEXT215 from '@/components/Text/215'
 import TEXT216 from '@/components/Text/216'
 import TEXT217 from '@/components/Text/217'
 import TEXT218 from '@/components/Text/218'
 import TEXT219 from '@/components/Text/219'
 import TEXT220 from '@/components/Text/220'
 import TEXT221 from '@/components/Text/221'
 import TEXT222 from '@/components/Text/222'
 import TEXT223 from '@/components/Text/223'
 import TEXT2ACK from '@/components/Text/2ack'
 import TEXTSUITABLEFORFRAMING from '@/components/Text/SuitableForFraming'
 import TEXT3COPYRIGHT from '@/components/Text/3copyright'
 import TEXT31 from '@/components/Text/31'
 import TEXT32 from '@/components/Text/32'
 import TEXT33 from '@/components/Text/33'
 import TEXT34 from '@/components/Text/34'
 import TEXT35 from '@/components/Text/35'
 import TEXT36 from '@/components/Text/36'
 import TEXT37 from '@/components/Text/37'
 import TEXT38 from '@/components/Text/38'
 import TEXT39 from '@/components/Text/39'
 import TEXT310 from '@/components/Text/310'
 import TEXT311 from '@/components/Text/311'
 import TEXT312 from '@/components/Text/312'
 import TEXT313 from '@/components/Text/313'
 import TEXT314 from '@/components/Text/314'
 import TEXT315 from '@/components/Text/315'
 import TEXT316 from '@/components/Text/316'
 import TEXT317 from '@/components/Text/317'
 import TEXT318 from '@/components/Text/318'
 import TEXT319 from '@/components/Text/319'
 import TEXT320 from '@/components/Text/320'
 import TEXT321 from '@/components/Text/321'
 import TEXT322 from '@/components/Text/322'
 import TEXT3ACK from '@/components/Text/3ack'
 import TEXTACTOFBETRAYAL from '@/components/Text/ActOfBetrayal'
 import TEXT4COPYRIGHT from '@/components/Text/4copyright'
 import TEXT41 from '@/components/Text/41'
 import TEXT42 from '@/components/Text/42'
 import TEXT43 from '@/components/Text/43'
 import TEXT44 from '@/components/Text/44'
 import TEXT45 from '@/components/Text/45'
 import TEXT46 from '@/components/Text/46'
 import TEXT47 from '@/components/Text/47'
 import TEXT48 from '@/components/Text/48'
 import TEXT49 from '@/components/Text/49'
 import TEXT410 from '@/components/Text/410'
 import TEXT411 from '@/components/Text/411'
 import TEXT412 from '@/components/Text/412'
 import TEXT413 from '@/components/Text/413'
 import TEXT414 from '@/components/Text/414'
 import TEXT415 from '@/components/Text/415'
 import TEXT416 from '@/components/Text/416'
 import TEXT417 from '@/components/Text/417'
 import TEXT418 from '@/components/Text/418'
 import TEXT419 from '@/components/Text/419'
 import TEXT420 from '@/components/Text/420'
 import TEXT421 from '@/components/Text/421'
 import TEXT422 from '@/components/Text/422'
 import TEXT423 from '@/components/Text/423'
 import TEXT4ACK from '@/components/Text/4ack'
 import TEXTMARGINOFERROR from '@/components/Text/MarginOfError'
 import TEXT5COPYRIGHT from '@/components/Text/5copyright'
 import TEXT51 from '@/components/Text/51'
 import TEXT52 from '@/components/Text/52'
 import TEXT53 from '@/components/Text/53'
 import TEXT54 from '@/components/Text/54'
 import TEXT55 from '@/components/Text/55'
 import TEXT56 from '@/components/Text/56'
 import TEXT57 from '@/components/Text/57'
 import TEXT58 from '@/components/Text/58'
 import TEXT59 from '@/components/Text/59'
 import TEXT510 from '@/components/Text/510'
 import TEXT511 from '@/components/Text/511'
 import TEXT512 from '@/components/Text/512'
 import TEXT513 from '@/components/Text/513'
 import TEXT514 from '@/components/Text/514'
 import TEXT515 from '@/components/Text/515'
 import TEXT519 from '@/components/Text/519'
 import TEXT516 from '@/components/Text/516'
 import TEXT517 from '@/components/Text/517'
 import TEXT518 from '@/components/Text/518'
 import TEXT520 from '@/components/Text/520'
 import TEXT521 from '@/components/Text/521'
 import TEXT522 from '@/components/Text/522'
 import TEXT523 from '@/components/Text/523'
 import TEXT524 from '@/components/Text/524'
 import TEXT525 from '@/components/Text/525'
 import LOVE_2 from '@/components/love_2'
 import TEXT5ACK from '@/components/Text/5ack'
 import TEXTMOREFROM from '@/components/Text/morefrom'
 import TEXTCONNECT from '@/components/Text/connect'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/BrittMontero",
 			"name" : "Text/BrittMontero",
 			"component" : TEXTBRITTMONTERO
 		},
 		{
 			"path" : "/Text/copyright",
 			"name" : "Text/copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/ContentsUnderPressure",
 			"name" : "Text/ContentsUnderPressure",
 			"component" : TEXTCONTENTSUNDERPRESSURE
 		},
 		{
 			"path" : "/Text/1copyright",
 			"name" : "Text/1copyright",
 			"component" : TEXT1COPYRIGHT
 		},
 		{
 			"path" : "/Text/11",
 			"name" : "Text/11",
 			"component" : TEXT11
 		},
 		{
 			"path" : "/Text/12",
 			"name" : "Text/12",
 			"component" : TEXT12
 		},
 		{
 			"path" : "/Text/13",
 			"name" : "Text/13",
 			"component" : TEXT13
 		},
 		{
 			"path" : "/Text/14",
 			"name" : "Text/14",
 			"component" : TEXT14
 		},
 		{
 			"path" : "/Text/15",
 			"name" : "Text/15",
 			"component" : TEXT15
 		},
 		{
 			"path" : "/Text/16",
 			"name" : "Text/16",
 			"component" : TEXT16
 		},
 		{
 			"path" : "/Text/17",
 			"name" : "Text/17",
 			"component" : TEXT17
 		},
 		{
 			"path" : "/Text/18",
 			"name" : "Text/18",
 			"component" : TEXT18
 		},
 		{
 			"path" : "/Text/19",
 			"name" : "Text/19",
 			"component" : TEXT19
 		},
 		{
 			"path" : "/Text/110",
 			"name" : "Text/110",
 			"component" : TEXT110
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js